import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/storage";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";

export const firebaseConfig = {
  apiKey: "AIzaSyAwpAfqx51neG7mL0IdP2ZAMzznFoIDt4I",
  authDomain: "edu-dungeon.firebaseapp.com",
  projectId: "edu-dungeon",
  storageBucket: "edu-dungeon.firebasestorage.app",
  messagingSenderId: "85878505575",
  appId: "1:85878505575:web:948ebc5776809482e094c2",
  measurementId: "G-6563GNK64T"
};

firebase.initializeApp(firebaseConfig);
if (process.env.REACT_APP_ENV === "local") {
  firebase.storage().useEmulator("localhost", 9199);
}
const db = getFirestore();
if (process.env.REACT_APP_ENV === "local") {
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
}

export function getDb() {
  return db;
}

export function getUserId() {
  return firebase.auth().currentUser.uid;
}

export const callFunction = async (
  endpoint,
  data = {},
  method = "POST",
  headers = {},
  responseType = "json",
) => {
  try {
    const isProd =
      process.env.NODE_ENV && process.env.NODE_ENV === "production";
    const user = firebase.auth().currentUser;
    // Only fetch a new token if we have a user and no Authorization set yet
    let token;
    if (user) {
      try {
        token = await user.getIdToken();
      } catch (_e) {
        token = undefined;
      }
    }
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    headers["Content-Type"] = "application/json";
    headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
    headers["Pragma"] = "no-cache";
    headers["Expires"] = "0";

    // Normalize method: accept boolean (true => POST, false => GET), string, or null/undefined
    const normalizedMethod =
      typeof method === "string"
        ? method.toUpperCase()
        : method === false
        ? "GET"
        : "POST";

    let options = {
      method: normalizedMethod,
      headers: headers,
    };

    if (normalizedMethod === "GET") {
      const searchParams = new URLSearchParams(data);
      const queryString = searchParams.toString();
      if (queryString) {
        endpoint = `${endpoint}?${queryString}`;
      }
    } else {
      options.body = JSON.stringify(data);
    }

    const url = isProd
      ? `/api/${endpoint}`
      : `http://127.0.0.1:5001/edu-dungeon/europe-west1/api/${endpoint}`;
    
    const response = await fetch(url, options);

    const result = { ok: response.ok, status: response.status };
    if (responseType === "blob") {
      const blob = await response.blob();
      return { ...result, blob };
    }
    let json = null;
    try {
      json = await response.json();
    } catch (_e) {
      // Non-JSON response
    }
    // If response is an array, return it directly with status info attached
    if (Array.isArray(json)) {
      Object.assign(json, result);
      return json;
    }
    if (json && typeof json === "object") {
      return { ...json, ...result };
    }
    return { data: json, ...result };
  } catch (e) {
    console.error("API call failed:", e);
    return { error: "API call failed" };
  }
};
